import { useFn } from '@eturi/react'
import {
	addOnboardingConcern,
	getOnboardingLabel,
	onboardingAvailableConcerns$,
	onboardingUserConcerns$,
	removeOnboardingConcern,
} from '@op/services'
import cls from 'classnames'
import { useSelector } from 'react-redux'
import { currentLang$ } from '../../../compound-selectors/language'
import { useAppDispatch } from '../../../types'
import { OptionTile } from '../../../widgets/Tiles/OptionTile/OptionTile'
import { OnboardingScreen } from './OnboardingScreen'

export const OnboardingConcernsScreen = () => {
	const d = useAppDispatch()
	const availableConcerns = useSelector(onboardingAvailableConcerns$)
	const currentLang = useSelector(currentLang$)
	const onboardingConcerns = useSelector(onboardingUserConcerns$)

	const hasSelectedConcern = useFn((concernId: string) =>
		onboardingConcerns.some((c) => c.id === concernId),
	)

	const handleConcernToggle = useFn((concernId: string) => {
		const concern = availableConcerns.find((c) => c.id === concernId)

		if (!concern) return

		d((hasSelectedConcern(concernId) ? removeOnboardingConcern : addOnboardingConcern)(concern))
	})

	return (
		<OnboardingScreen>
			<OnboardingScreen.Header>
				What are your main concerns for smartphone use?
			</OnboardingScreen.Header>

			<OnboardingScreen.Content>
				<p className="text-center text-balance mb-4">Select all that apply</p>

				<div className="w-full grid xs:grid-cols-2 gap-2">
					{availableConcerns.map((concern) => (
						<OptionTile
							onClick={() => handleConcernToggle(concern.id)}
							active={hasSelectedConcern(concern.id)}
							key={concern.id}
							className={cls(
								'w-full p-1',
								hasSelectedConcern(concern.id) ? 'bg-teal-2hl' : 'bg-white',
							)}
						>
							{getOnboardingLabel(concern.label, currentLang)}
						</OptionTile>
					))}
				</div>
			</OnboardingScreen.Content>
		</OnboardingScreen>
	)
}
